var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loot__button"},[_c('div',{staticClass:"button button--corner button--animated gtm-button gtm-get-kit",on:{"click":function($event){return _vm.takeRewards()}}},[_vm._v("\n    "+_vm._s(_vm.$t("loot.take_all"))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }